"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _Sidebar = _interopRequireDefault(require("./Sidebar"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "sidebar": "DefaultTheme__sidebar___36TsA",
  "menu-back": "DefaultTheme__menu-back___1Lwwk",
  "icon": "DefaultTheme__icon___Q4sZN",
  "menuBack": "DefaultTheme__menu-back___1Lwwk"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "sidebar": "DarkTheme__sidebar___35zPP",
  "list-heading": "DarkTheme__list-heading___20CGg",
  "anchor": "DarkTheme__anchor___3FH2Z",
  "menu-back": "DarkTheme__menu-back___8GLL8",
  "listHeading": "DarkTheme__list-heading___20CGg",
  "menuBack": "DarkTheme__menu-back___8GLL8"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "sidebar": "LumeTheme__sidebar___2UaF6",
  "menu-back": "LumeTheme__menu-back___VUFMt",
  "menuBack": "LumeTheme__menu-back___VUFMt"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedSidebar = (0, _reactCssThemr.themr)(_Sidebar["default"].displayName, themes.DefaultTheme)(_Sidebar["default"]);
ThemedSidebar.displayName = _Sidebar["default"].displayName;
ThemedSidebar.themes = themes;
var _default = exports["default"] = ThemedSidebar;
//# sourceMappingURL=index.js.map